import React from 'react';

export function DetailCard({ item, fields, context, striped, action }) {
    return (
        <li className={`flex items-start gap-2 py-4 px-2.5 border-b border-[#d4d4d4] last:border-b-0 ${striped ? 'bg-[#f5f5f5]' : ''}`}>
            <dl className="grid grid-cols-[minmax(min-content,40%)_minmax(0,1fr)] gap-x-4 gap-y-1.5 text-sm grow min-w-0">
                {fields.map((field) => (
                    <React.Fragment key={field.key}>
                        <dt className="font-bold text-[#003545]">{context.translate(field.label)}</dt>
                        <dd className="break-words">{field.render(item, context)}</dd>
                    </React.Fragment>
                ))}
            </dl>
            {action && <div className="shrink-0 -mt-2 -mr-1">{action}</div>}
        </li>
    );
}
